import React, { useContext, useState } from "react";
import verified from "../../images/verified.png";
import Swal from "sweetalert2";
import { UrlContext } from "../../contexts/UrlContext";
import { AnimatePresence, motion } from "framer-motion";

export default function Verified({
  isVerified,
  setIsVerified,
  expert_id,
  callingFrom = null,
}) {
  const [isVerifiedPopup, setIsVerifiedPopup] = useState(false);
  const { API_URL } = useContext(UrlContext);
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const handleIsVerified = () => {
    const url = `${API_URL}save-expert-verified`;
    const data = {
      expertID: expert_id,
      isVerified: !isVerified,
    };
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          setIsVerifiedPopup(false);
          setIsVerified(!isVerified);
          Swal.fire({
            icon: "success",
            title: "Success",
            showConfirmButton: false,
            timer: 1500,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            confirmButtonColor: "#365565"
          });
        }
      })
      .catch((err) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          confirmButtonColor: "#365565"
        });
      });
  };

  return (
    <>
      <div
        className="relative flex items-center"
        onMouseEnter={() => setTooltipOpen(true)}
        onMouseLeave={() => setTooltipOpen(false)}
      >
        {isVerified ? (
          <>
            <div style={{display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", marginTop: "2px", fontSize: callingFrom==='stickyBar' ? null : "24px"}} >
              <i class="fa-solid fa-certificate" style={{color: "#365561", cursor: "pointer"}} onClick={() => setIsVerifiedPopup(true)}></i>
              <i class="fa-solid fa-check" style={{color: "white", fontSize: callingFrom==='stickyBar' ? "10px" : "12px", position: "absolute", cursor: "pointer"}} onClick={() => setIsVerifiedPopup(true)}></i>
            </div>
          </>
        ) : (
          <>
            <div style={{display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", marginTop: "2px", fontSize: callingFrom==='stickyBar' ? null : "24px"}} >
              <i class="fa-solid fa-certificate" style={{color: "lightgrey", cursor: "pointer"}} onClick={() => handleIsVerified()}></i>
              <i class="fa-solid fa-check" style={{color: "white", fontSize: callingFrom==='stickyBar' ? "10px" : "12px", position: "absolute", cursor: "pointer"}} onClick={() => handleIsVerified()}></i>
            </div>
          </>
        )}
        {/* Tooltip (with Framer Motion) */}
        <AnimatePresence>
          {tooltipOpen && (
            <motion.div
              className={`absolute ${callingFrom==='stickyBar' ? 'top-0 left-5' : '-top-7 -left-10'} -translate-x-1/2 bg-[#365561] text-white text-xs px-2 py-1 rounded shadow-md whitespace-nowrap z-50 pointer-events-none`}
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 20 }}
              transition={{ duration: 0.3 }}
            >
              {isVerified ? (
                <span>Mark as Unverified</span>
              ) : (
                <span>Mark as Verified</span>
              )}
            </motion.div>
          )}
        </AnimatePresence>
      </div>
      {isVerifiedPopup && (
        <div className="prjdetails-removeVIP-popup-wrapper">
          <div className="tab-pane fade show prjdetails-removeVIP-div">
            <div>
              <center>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", fontSize: "30px"}} >
                  <i class="fa-solid fa-certificate" style={{color: "#365561", cursor: "pointer"}}></i>
                  <i class="fa-solid fa-check" style={{color: "white", fontSize: "15px", position: "absolute", cursor: "pointer"}}></i>
                </div>
                <p style={{color: "#365561", marginTop: "20px"}}>
                  Remove this expert from <strong>Verified</strong> list?
                </p>
                <br />
              </center>
            </div>
            <div>
              <center>
                <button
                  className="btn btn-light"
                  onClick={() => setIsVerifiedPopup(false)}
                >
                  Cancel
                </button>
                <button
                  className="btn base-btn"
                  style={{ marginLeft: "6px" }}
                  onClick={() => handleIsVerified()}
                >
                  Continue
                </button>
              </center>
            </div>
          </div>
        </div>
      )}
    </>
  );
}